import { FC } from 'react';

import styles from './LmmTableMaterieelRowSubHeader.module.css';

type LmmTableMaterieelRowSubHeaderProps = {
  subHeader: string;
};
const LmmTableMaterieelRowSubHeader: FC<LmmTableMaterieelRowSubHeaderProps> = ({ subHeader }) => {
  return (
    <div className={styles.tableRowHeader}>
      <div>
        <span className={styles.subHeader}>{subHeader}</span>
      </div>
    </div>
  );
};
export default LmmTableMaterieelRowSubHeader;
